import { useEffect, useState } from "react"
import { ReactComponent as SelectSvg } from './icons/select.svg'
import { ReactComponent as DropdownSvg } from 'bimui/dist/c1/icons/collapse.svg'
import { Input } from "antd"
import "./tree-select.less"
import classNames from "classnames"



export interface TreeSelectNode {
    /**
     * 节点key
     */
    key: string,
    /**
     * 节点值的数量（1/2）
     */
    valueCount: 1 | 2
    /**
     * 节点值1
     */
    value1?: string,
    /**
     * 节点值2
     */
    value2?: string,
    /**
     * 节点类型，区分用
     */
    type?: number,
    /**
     * 是否不可选
     */
    unSelectable?: boolean
    /**
     * 子节点列表
     */
    children?: TreeSelectNode[],
}

interface Iprops {
    treeList: TreeSelectNode[]

    searchValue?: string,

    selectKeyList: string[],

    wrapClassName?: string;

    setSelectKeyList: (key: string) => void
}

export default function TreeSelectComponent(props: Iprops) {

    const { treeList, searchValue, selectKeyList, wrapClassName, setSelectKeyList } = props

    /**
     * 树的源数据
     */
    const [originTreeList, setOriginTreeList] = useState<TreeSelectNode[]>([])
    /**
     * 页面展示的树
     */
    const [showTreeList, setShowTreeList] = useState<TreeSelectNode[]>([])
    /**
     * 页面展开的item的key的列表
     */
    const [showNodeKeyList, setShowNodeKeyList] = useState<string[]>([])

    useEffect(() => {
        if (!treeList) return
        setOriginTreeList([...treeList])
        if (searchValue?.length > 0) {
            setShowTreeList(filterTree(treeList, searchValue))
        } else {
            setShowTreeList([...treeList])
        }

    }, [treeList])


    /**
     * 根据searchString来组合树
     * @param nodes 
     * @param searchString 
     * @returns 
     */
    const filterTree = (nodes: TreeSelectNode[], searchString: string): TreeSelectNode[] => {
        const result: TreeSelectNode[] = [];

        for (const node of nodes) {
            // 递归查找子节点是否匹配
            const matchingChildren = node.children ? filterTree(node.children, searchString) : [];
            // 判断当前节点是否匹配
            const isMatch = node.value1?.includes(searchString) || node.value2?.includes(searchString);

            // 如果当前节点匹配，或者有匹配的子节点，当前节点返回
            if (isMatch || matchingChildren.length > 0) {
                result.push({
                    ...node,
                    children: matchingChildren, // 仅返回匹配的子节点
                });
            }
        }
        return result;
    };

    /**
     * 修改打开状态
     * @param node 
     */
    const onClickShowTreeNode = (node: TreeSelectNode) => {
        if (showNodeKeyList.includes(node.key)) {
            setShowNodeKeyList([...showNodeKeyList.filter(item => item != node.key)])
        } else {
            setShowNodeKeyList([
                ...showNodeKeyList,
                node.key
            ])
        }
    }

    const TreeNodeItem = (treeNode: NodeItem) => {
        return (
            <div className="node-item" key={treeNode?.node?.key}>
                <div className={classNames({
                    "item-head": true,
                    "item-head-active": false
                })} onClick={(e) => {
                    e.stopPropagation()
                }}>
                    <div className={classNames({
                        "select-box": true,
                        "select-box-active": selectKeyList?.includes(treeNode?.node?.key)
                    })} >
                        {!treeNode?.node?.unSelectable && (
                            <>
                                <div className="box-body" onClick={() => {
                                    setSelectKeyList(treeNode.node.key)
                                }} />
                                <SelectSvg className="box-select-icon" onClick={() => {
                                    setSelectKeyList(treeNode.node.key)
                                }} />
                            </>
                        )}

                    </div>

                    <div className="head-main" style={{
                        marginLeft: treeNode?.level * 16,
                        width: `calc(100% - ${treeNode?.level * 16}px - 16px)`
                    }}>
                        <div className="drop-down-area">
                            {treeNode?.node?.children?.length > 0 && (
                                <DropdownSvg className={classNames({
                                    "drop-down-svg": true,
                                    "drop-down-svg-active": showNodeKeyList.includes(treeNode?.node?.key)
                                })}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        onClickShowTreeNode(treeNode.node)
                                    }}
                                />
                            )}
                        </div>
                        <div className="head-value-1">
                            {treeNode?.node?.value1}
                        </div>
                        {treeNode?.node?.valueCount == 2 && (
                            <div className="head-value-2">
                                {treeNode?.node?.value2}
                            </div>
                        )}
                    </div>
                </div>
                {treeNode?.node?.children?.length > 0 &&
                    showNodeKeyList.includes(treeNode?.node?.key) &&
                    (
                        <>
                            {treeNode?.node?.children?.map((childrenNode) => (
                                <TreeNodeItem level={treeNode.level + 1} node={childrenNode} />
                            ))}
                        </>
                    )}
            </div>
        )
    }



    return (
        <div className={classNames({ "tree-select-component-main": true }, wrapClassName)} >
            {showTreeList?.map(nodeItem => (
                <TreeNodeItem level={0} node={nodeItem} />
            ))}
        </div>
    )
}

interface NodeItem {
    node: TreeSelectNode,
    level: number
}